<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="parttitle">PART I</h2>
<h2 class="parttitle">Individuality and Connectedness</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?ef60fb50